import { TriangleAlert } from 'lucide-react';
import { LiveActivityEmptyState } from '@/domains/live-activity/components/LiveActivityEmptyState';
import { CHART_NO_DATA_DESCRIPTION, CHART_NO_DATA_TITLE } from '@/constants/misc.constants';

type Props = {
  className?: string;
  title?: string;
  /** Omit for default no-data copy; pass `''` to hide; with custom `title`, omit for title-only. */
  description?: string;
  /** Overrides default max-width for the description line(s). */
  descriptionClassName?: string;
};

/** Icon + title + description, same layout as All reports / My reports empty states. */
export function ChartNoDataEmptyState({
  className,
  title,
  description,
  descriptionClassName = 'max-w-[280px] sm:max-w-[320px]',
}: Props) {
  const resolvedTitle = title ?? CHART_NO_DATA_TITLE;
  const resolvedDescription =
    description !== undefined ? description || undefined : title !== undefined ? undefined : CHART_NO_DATA_DESCRIPTION;

  return (
    <LiveActivityEmptyState
      Icon={TriangleAlert}
      title={resolvedTitle}
      description={resolvedDescription}
      className={className}
      descriptionClassName={descriptionClassName}
    />
  );
}
